import React from 'react';
import { PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Auth/autoContext";
import { useTranslation } from "react-i18next";
import { getCurrentUser, refreshHeaderLogin } from '../Data/dataApi';
import { createPayPalSubscription, activateSubscription } from "../Data/dataApi";
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet-async';

const getUserProfile = () => {
  const userStr = sessionStorage.getItem("user");
  return userStr ? JSON.parse(userStr) as { id: number; userName: string; firstName: string; lastName: string } : null;
};

const UpgradePremium: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { login: setAuthRole } = useAuth();

  const handleApprove = async (data: any) => {
    try {
      const user = getUserProfile();

      console.log(user);

      if (!user || !user.id) {
        throw new Error("Utilisateur invalide ou ID manquant");
      }

      console.log("PayPal data:", data);

      await activateSubscription({
        userId: user.id.toString(),
        subscriptionId: data.subscriptionID
      });

      // 🔥 RELOAD USER FROM BACKEND
      const updatedUser = await getCurrentUser();

      sessionStorage.setItem("user", JSON.stringify(updatedUser));

      // 🔥 update context
      const isPremium = updatedUser?.role === "premium";
      setAuthRole(isPremium ? "premium" : "public");
      sessionStorage.setItem("userRole", isPremium ? "premium" : "public");

      sessionStorage.removeItem("list-cache");
      sessionStorage.removeItem("agenda-cache");

      // 🔥 notifier toute l'app
      refreshHeaderLogin();

      // toast.success("🎉 Abonnement Premium activé ! Vous pouvez maintenant profiter des fonctionnalités Premium.");
      navigate("/list", {
        state: { success: "premium_activated" }
      });

    } catch (err) {
      console.error("Erreur activation abonnement :", err);
      toast.error("Erreur lors de l'activation du premium.");
    }
  };

  const createSubscriptionHandler = async () => {
    const user = getUserProfile();

    if (!user) throw new Error("Utilisateur non connecté");

    const result = await createPayPalSubscription({
      subscriber: {
        givenName: user.firstName,
        surname: user.lastName,
        email: user.userName
      }
    });

    return result.subscriptionId;
  };

  return (
    <>
      <Helmet>
        <title>
          Upgrade to Premium | Stockifly
        </title>

        <meta
          name="description"
          content="Upgrade of Stockifly"
        />
      </Helmet>

      <div className="payment-container">
        <h2 id='payment-title'>{t("upgrade.title")}</h2><br />
        <p className='payment-subtitle'>{t("upgrade.subtitle")}</p>
        <br />
        <ul>
          <li>Accès complet à toutes les prévisions boursières</li>
          {/* <li>Alertes personnalisées pour vos indices</li>
        <li>Export des données historiques</li> */}
          <li>Support prioritaire</li>
        </ul><br />
        <p>Prix après essai : 59.99 U$ / mois</p>
        <br /><br />
        <PayPalButtons
          style={{ layout: "vertical" }}
          createSubscription={createSubscriptionHandler}
          onApprove={handleApprove}
          onError={(err: any) => {
            console.error("Erreur PayPal :", err);
            toast.error("Une erreur est survenue pendant le paiement.");
          }}
        />
      </div>
    </>
  );
};

export default UpgradePremium;